import {green, grey} from "@material-ui/core/colors";
import { getTheme } from "./theme";

const VehicleCarouselStyles = (theme) => ({
    '& .vehicle-carousel-box': {
        '& .control': {
            justifyContent: 'space-between',
            paddingBottom: '10px',
            // marginTop: '-36px',
            '& a': {
                 textTransform: 'uppercase',
                 textDecoration: 'none',
                 fontFamily: 'Mulish',
                 fontSize: '12px',
                 lineHeight: '15px',
                 fontWeight: 'bold',
                 color: getTheme(theme).colorFormTitle
             } 
        },
        '& .vehicle-carousel': {
            width: '456px',
            
            '& .carousel': {
                overflow: 'inherit',
                '& .control-arrow': {
                    //display: 'none'
                    top: 'auto',
                    bottom: '-74px',
                    opacity: '1',
                    padding: '0',
                    textTransform: 'uppercase',
                    textDecoration: 'none',
                    fontFamily: 'Mulish',
                    fontSize: '12px',
                    lineHeight: '15px',
                    fontWeight: 'bold',
                    color: getTheme(theme).colorFormTitle,
                    '&.control-next': {
                        right: '-10px'
                    },
                    '&.control-prev': {
                        left: '0'
                    },
                    '&:hover': {
                        background: 'none'
                    },
                    '&:before': {
                        content: 'none'
                    },
                    //'&.control-disabled': {
                        // display: 'inherit',
                        // opacity: '1',
                        // cursor: ''
                    //}
                },
                '& .slide': {
                    //minWidth: '456px'
                    '& .img img': {
                        //maxHeight: '290px',
                        maxHeight: '342px',
                        objectFit: 'cover'
                    }
                },
                '& .control-dots': {
                    display: 'none'
                }
            },
            '& .thumbs-wrapper': {
                margin: '0',
                '& .control-arrow': {
                    display: 'none'
                    // position: 'absolute',
                    // bottom: '-50px'
                },
                '& .thumbs': {
                    paddingLeft: '1px',
                    marginTop: '8px',
                    marginBottom: '8px',
                    '& .thumb': {
                        border: 'none',
                        width: 'auto !important',
                        marginRight: '18px',
                        padding: '3px 0',
                        '& img': {
                            width: '60px',
                            height: '45px',
                            objectFit: 'cover'
                        },
                        '&.selected': {
                            padding: '0',
                            border: '3px solid white'
                        }
                    }
                }
            }
        }
     }
})

const VehicleCarouselMobileStyles = (theme) => ({
    '& .vehicle-carousel-box': {
        //paddingBottom: '20px',
        '& .vehicle-carousel': {
            width: '340px',
            '& .carousel': {
                //paddingBottom: '40px',
                '& .control-arrow': {
                    bottom: '-34px',
                    '&.control-next': {
                        right: '0'
                    },
                    '&.control-prev': {
                        left: '0'
                    },
                },
                '& .control-dots': {
                    bottom: '-55px',
                    display: 'block',
                    position: 'absolute',
                    // position: 'relative',
                    margin: 'auto',
                    //width: '60%',
                    lineHeight: '20px',
                    padding: '6px 68px 10px 62px',
                    minHeight: '56px',
                    '& .dot': {
                        margin: '0 4px',
                        backgroundColor: getTheme(theme).colorDashboardWidgetText,
                        opacity: 1,
                        '&.selected': {
                            backgroundColor: getTheme(theme).colorArrowCollapsed
                        }
                    }
                }
            },
            '& .slide': {
                '& .img img': {
                    maxHeight: '230px',
                    objectFit: 'cover'
                }
            },
            '& .thumbs-wrapper': {
                display: 'none'
            }
        }
    }
});

const DashboardStyles = (theme) => {
    const offerAmountBox = {
        marginRight: '5px',
        fontWeight: 'bold',
        fontSize: '24px',
        lineHeight: '30px',
        color: '#00AEEF'
    };
    const expiresAtBox = {
        fontStyle: 'italic',
        fontSize: '16px',
        lineHeight: '20px',
        marginTop: '2px'
    };
    const colorGrey = {
        color: grey[500]
    };
    const colorBlue = {
        color: '#00AEEF'
    };
    const colorWhite = {
        color: 'white'
    };

    return {
        dashboard: {
            color: grey[500],
        },
        dashboardItem: {
            border: 1,
            borderColor: grey[500],
            borderStyle: "solid",
            marginTop: '-1px'
        },
        icon: {
            marginRight: theme.spacing(2)
        },
        MenuItem: {
            color: '#feffff'
        },
        dashboardRoot: {
            marginTop: '19px'
        },
        box: {
            marginLeft: '16px', marginRight: '16px', marginTop: '19px'
        },
        indentLineBefore: {
            marginTop: '10px'
        },
        selectedVehicleDetailRoot: {
            '& .box-caption': {
                marginRight: '5px',
                fontWeight: 'bold'
            },
            '& .data-box': {
                fontSize: '16px',
                textTransform: "capitalize"
            },
            '& .frame-carousel': {
                display: 'flex',
                flexDirection: 'row',
                ...VehicleCarouselStyles(theme),
                '&.mobile': {
                    ...VehicleCarouselMobileStyles(theme)
                }
            },
            '& .status': {
                padding: '10px 0 0 0',
                fontSize: '20px',
                fontWeight: 'bold',
                lineHeight: '25px',
                '& span': {
                    color: getTheme().colorDashboardWidgetValue,
                    textTransform: 'capitalize'
                }
            }
        },
        offerDetailVehicleBox: {
            ...colorBlue,
            lineHeight: '30px',
            fontSize: '24px'
        },
        offerDetailVinBox: {
            ...colorWhite,
            fontSize: '16px',
            lineHeight: '20px'
        },
        offerDetailOfferTitle: {
            ...colorWhite,
            marginTop: '10px',
            fontSize: '28px',
            lineHeight: '35px',
            textAlign: 'center'
        },
        offerDetailAmount: {
            ...colorBlue,
            fontSize: '28px',
            fontWeight: 'bold',
            lineHeight: '35px'
        },
        offerDetailByClient: {
            ...colorWhite,
            fontSize: '20px',
            // fontWeight: 'bold',
            lineHeight: '25px'
        }, 
        offerDetailOfferText: {
            ...colorWhite,
            fontSize: '16px',
            lineHeight: '20px',
            paddingBotton: '10px'
        },
        expiresAtBox: {
            ...expiresAtBox
        },
        offerAcceptedBox: {
            fontWeight: 'bold',
            fontSize: '16px',
            lineHeight: '20px',
            marginTop: '2px'
        },
        offerByClientBox: {
            fontWeight: 'bold',
            fontSize: '16px',
            lineHeight: '20px',
            marginTop: '2px'
        },
        offerAcceptButtonBox: {
            justifyContent: 'center',
            margin: 'auto'
        },
        centeredFixedBox: {
            width: '100%',
            textAlign: 'center',
            marginBottom: '10px'
        },
        bottomControlBox: {
            marginTop: '30px',
            marginRight: '10px',
            textAlign: 'right'
        },
        title: {
            fontSize: '24px',
            lineHeight: '30px'
        },
        alignCenter: {
            justifyContent: 'center'
        },
        alignRight: {
            textAlign: 'right'
        },
        expansionBox: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        width100p: {
            width: '100%'
        },
        width94p: {
            width: '94%'
        },
        button: {
            marginLeft: theme.spacing(1),
        },
        buttonProgress: {
            color: green[500],
            position: 'absolute',
        },
        offerAmountBox: {
            ...offerAmountBox
        },
        offerAmountExpiredBox: {
            ...offerAmountBox,
            ...colorGrey
        },
        colorBlue: {
            ...colorBlue
        },
        colorWhite: {
            color: 'white'
        },
        colorGrey: {
            ...colorGrey
        },
        sizeLarge: {
            fontSize: '28px'
        },
        sizeMedium: {
            fontSize: '24px',
        },
        sizeSmall: {
            fontSize: '18px'
        },
        offerAmountBoxLarge: {
            fontSize: '24px',
            color: '#00AEEF'
        },
        dataBox: {
            fontSize: '16px',
            textTransform: "capitalize"
        },
        dividerGrid: {
            marginTop: '15px',
            marginBottom: '15px'
        },
        helpButtonGrid: {
            marginTop: '10px',
            textAlign: 'center'
        },
        divider: {
            backgroundColor: '#9e9e9e'
        },
        comingSoonBox: {
            paddingBottom: '40px'
        },
        badge: {
            color: 'white'
        },
        bageBox: {
            marginLeft: '20px'
        },
        dialogPaper: {
            backgroundColor: "#323334",
            color: "white"
        },
        dialogTitle: {
            color: '#00AEEF',
            fontSize: '24px',
            lineHeight: '30px',
            fontWeight: 'bold',
            paddingTop: '15px',
            paddingBottom: '15px',
            alignItems: 'center',
            textAlign: 'center',
        },
        dialogText:{
            fontSize: '20px',
            lineHeight: '25px'
        },
        messageTextArea:{
            backgroundColor: "transparent",
            color: "#FFFFFF"
        },
        dialogActions:{
            justifyContent: 'flex-end',
            paddingRight: "16px"
        },
        dialogContent:{
            paddingRight: "16px",
            paddingLeft: "16px"
        },
        appointedAtBox:{
            ...colorWhite,
            fontSize: '18px',
            lineHeight: '20px',
            marginTop: '2px'
        },
        appointmentTypeBox: {
            fontWeight: 'bold',
            fontSize: '20px',
            lineHeight: '20px',
            marginTop: '2px'
        },
        appointmentDetailsButtonBox: {
            justifyContent: 'center',
            margin: 'auto'
        },
        appointmentAddressTitleBox: {
            ...colorWhite,
            fontWeight: 'bold',
            fontSize: '20px',
            lineHeight: '20px',
            marginTop: '20px'
        },
        appointedAddressBox:{
            ...colorWhite,
            fontSize: '16px',
            lineHeight: '20px',
            marginTop: '2px'
        },
        appointmentDetailText: {
            ...colorWhite,
            fontSize: '16px',
            lineHeight: '20px',
            paddingBotton: '10px'
        },
    }
};

const FooterStyles = (theme) => ({
    footerPanel: {
        width: "100%",
        left: 0,
        marginTop: '30px',
        bottom: 0,
        alignItems: 'center',
        justifyContent: 'center',
        //background: '#303030',
        zIndex: 1000,
        paddingBottom: theme.spacing(1),
        position: 'absolute'
    },
    footerText: {
        fontSize: '9px',
    },
    supportPanel: {
        width: "100%",
        right: "16px",
        marginTop: '30px',
        bottom: "20px",
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        //background: '#303030',
        zIndex: 1000,
        paddingBottom: theme.spacing(1),
        position: 'absolute'
    },


});


export {DashboardStyles, FooterStyles}